import { Sidebar } from './Sidebar';
import { Header } from './Header';
import { BottomNav } from './BottomNav';
import { SearchContext } from '@/App';
import { ConceptBanner } from './ConceptBanner';
import { SubViewChips } from './SubViewChips';

export const PageLayout = ({ title, concept = false, children }) => {
  return (
    <div className="min-h-screen bg-background">
      <Sidebar />
      <Header
        title={title}
        onOpenSearch={() => SearchContext.setOpen(true)}
      />
      <BottomNav />
      <main className="lg:ml-60 mt-16 p-8 pb-20 lg:pb-8">
        <div className="animate-fade-in-up">
          {concept && <ConceptBanner />}
          <SubViewChips />
          {children}
        </div>
      </main>
    </div>
  );
};
